// Extract local calendar date (YYYY-MM-DD) regardless of timezone.
// Works with ISO strings or Date objects; used to avoid off-by-one drift
// when DateRangePicker returns Date objects in UTC+N and we need the
// day the user actually intended to select.
const toYMD = (d) => {
    if (typeof d === 'string') return d.split('T')[0];
    const dt = new Date(d);
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, '0');
    const day = String(dt.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
};

export default toYMD;
